import React, { useState, useEffect, useRef } from 'react';
import * as BABYLON from '@babylonjs/core';
import '@babylonjs/loaders';
import { callApi, ErrorAlert } from './utils';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import MultipleSelectCheckmarks from './MultipleSelectCheckmarks';
import Form from 'react-bootstrap/Form';
import AutoComplete from './AutoComplete';
import useApp from './../AppContext';
const Viewer3D = (props) => {
    const app = useApp();
    const canvasRef = useRef(null);
    const sceneRef = useRef(null);
    const engineRef = useRef(null);
    const [serverUrl] = useState(app.serverUrl);
    const [aisles, setAisles] = useState([]);
    const [error, setError] = useState(null);
    const [aisleList, setAisleList] = useState(null);
    const [selectedAisles, setSelectedAisles] = useState(null);
    const [splitSide,setSplitSide]=useState(true);
    const [itemId, setItemId] = useState(null);
    const [itmLocationList, setItmLocationList] = useState(null);
    const column = {columnName:"ItemCode",secondaryField:"Descr1",lookUpQuery:"{Items{ItemId ItemCode Descr1}}"};
    const language = app.sessionToken?.Language;
    useEffect(() => {
           async function getItmLocationList() {
                try {
                    if (!serverUrl) return;
                    if (!itemId || !selectedAisles) {
                        setItmLocationList(null);
                        return;
                    }
                    const itmLocationList = await callApi('GET', `${serverUrl}//api/threed?aisles=${selectedAisles}&itemId=${itemId}`);
                    setItmLocationList(itmLocationList);
                } catch (err) {
                    setError(err.message);
                }
            };
            getItmLocationList();
        }, [itemId, serverUrl, selectedAisles]);

    useEffect(() => {
        async function getAisleList() {
            try {
                if (!serverUrl) return;
                const aisleList = await callApi('GET', `${serverUrl}/api/threed/aisles`);
                setAisleList(aisleList);
            } catch (err) {
                setError(err.message);
            }
        };
        getAisleList();
    }, [serverUrl]);

    useEffect(() => {
        async function getAisles() {
            try {
                if (!serverUrl) return;
                setAisles(await callApi('GET', `${serverUrl}//api/threed?aisles=${selectedAisles}&splitSide=${splitSide}`));
            } catch (err) {
                setError(err.message);
            }
        };
        getAisles();
    }, [serverUrl,selectedAisles,splitSide,itemId]);

    useEffect(() => {
        const bayWidth = 0.8;
        const bayDepth = 1.2;
        const verticalSpacerWidth = 0.1;
        const verticalSpacerThickness = 0.1;
        const horizontalSpacerHeight = 0.1;
        const horizontalSpacerWidth = 0.1;
        const horizontalSpacerSpacing = 1.8;
//         const movementSpeed = 0.1;
        const aisleSpacing = 3.0;  // Additional space between aisles
        let curZ = 0;
        let minX = 0;


        const drawGround = () => {
            const ground = BABYLON.MeshBuilder.CreateGround('ground', { width: 50, height: 50 }, sceneRef.current);
            const groundMaterial = new BABYLON.StandardMaterial('groundMaterial', sceneRef.current);
            const groundTexture = new BABYLON.Texture('floorTexDiffuse.jpg', sceneRef.current);
            groundTexture.uScale = 5;
            groundTexture.vScale = 5;
            groundMaterial.diffuseTexture = groundTexture;
            ground.material = groundMaterial;
            ground.position.y = -0.5; // Adjust the position if needed
        };

        const drawWalls = () => {
                                                 
                                       
            const wallHeight = 10.0;

                               
            const frontWall = BABYLON.MeshBuilder.CreatePlane('frontWall', { width: 50, height: wallHeight }, sceneRef.current);
            frontWall.position.y = wallHeight / 2.25;
            frontWall.position.z = 25;
            frontWall.material = new BABYLON.StandardMaterial('frontWallMaterial', sceneRef.current);
            frontWall.material.diffuseColor = new BABYLON.Color3(0.5, 0.5, 0.5); // Gray color

                               
            const leftWall = BABYLON.MeshBuilder.CreatePlane('leftWall', { width: 50, height: wallHeight, sideOrientation: BABYLON.Mesh.DOUBLESIDE }, sceneRef.current);
            leftWall.position.y = wallHeight / 2.25;
            leftWall.position.x = -25;
            leftWall.rotation.y = -Math.PI / 2;
            leftWall.material = new BABYLON.StandardMaterial('leftWallMaterial', sceneRef.current);
            leftWall.material.diffuseColor = new BABYLON.Color3(0.5, 0.5, 0.5); // Gray color

                               
            const rightWall = BABYLON.MeshBuilder.CreatePlane('rightWall', { width: 50, height: wallHeight, sideOrientation: BABYLON.Mesh.DOUBLESIDE }, sceneRef.current);
            rightWall.position.y = wallHeight / 2.25;
            rightWall.position.x = 25;
            rightWall.rotation.y = Math.PI / 2;
            rightWall.material = new BABYLON.StandardMaterial('rightWallMaterial', sceneRef.current);
            rightWall.material.diffuseColor = new BABYLON.Color3(0.5, 0.5, 0.5); // Gray color

            const textPlane = BABYLON.MeshBuilder.CreatePlane('textPlane', { width: 10, height: 2 }, sceneRef.current);
            textPlane.position.y = wallHeight - 2;
            textPlane.position.z = 24.9;

            const dynamicTexture = new BABYLON.DynamicTexture('dynamicTexture', { width: 512, height: 256 }, sceneRef.current, false);
            const context = dynamicTexture.getContext();

            context.fillStyle = 'white';
            context.fillRect(0, 0, 512, 256);

            context.font = 'bold 70px Arial';
            context.fillStyle = 'black';
            const text = "aberon WMS";
            const textWidth = context.measureText(text).width;
            context.fillText(text, (512 - textWidth) / 2, 150); // Centered horizontally

            dynamicTexture.update();

            const textMaterial = new BABYLON.StandardMaterial('textMaterial', sceneRef.current);
            textMaterial.diffuseTexture = dynamicTexture;

            textPlane.material = textMaterial;
        };


        const drawBoxes = (parentNode, boxType) => {
            const boxWidth = 0.25;
            const boxLength = 0.2;
            const boxHeight = 0.6;
            const boxSpacing = 0.1;

            const lightBrownColor = new BABYLON.Color3(0.8, 0.6, 0.4);
            const material = new BABYLON.StandardMaterial('boxMaterial', sceneRef.current);
            material.diffuseColor = lightBrownColor;
           
            //const numberofboxes = boxType;


            for (let i = 0; i < boxType; i++) {
           
                const box = BABYLON.MeshBuilder.CreateBox(`box_${i}`, { width: boxWidth, height: boxHeight, depth: boxLength }, sceneRef.current);
               
                if (boxType === 1) {
                           
                    box.position.x = 0;
                    box.position.z = 0;
                } else if (boxType === 2) {
                           
                    box.position.x = ((i === 0 ? -1 : 1) * (boxWidth / 2 + boxSpacing / 2));
                    box.position.z = 0;
                } else if (boxType === 3) {
                           
                    box.position.x = ((i % 2 === 0 ? -1 : 1) * (boxWidth / 2 + boxSpacing / 2));
                    box.position.z = (i < 2 ? -1 : 1) * (boxLength / 2 + boxSpacing / 2);
                } else if (boxType === 4) {
                           
                    box.position.x = ((i % 2 === 0 ? -1 : 1) * (boxWidth / 2 + boxSpacing / 2));
                    box.position.z = (i < 2 ? -1 : 1) * (boxLength / 2 + boxSpacing / 2);
                             
                           
                             
                }
                box.position.y = (boxHeight / 4) + 0.15;
                                   
                box.parent = parentNode;
                box.material = material;
             
        }
    }
const palletMap = new Map(); // Map to store created pallets

const drawPallet = async (boxType, locationid, itmLocationList) => {
    let pallet = palletMap.get(locationid); // Check if pallet for location already exists

    if (!pallet) {
        let palletFile = 'Pallet.glb'; 

        if (itmLocationList && itmLocationList.some(item => item.locationId === locationid)) {
            palletFile = 'RedPallet.glb';
        } 


        pallet = await new Promise((resolve, reject) => {
            BABYLON.SceneLoader.ImportMesh(
                '',
                palletFile,
                '',
                sceneRef.current,
                (meshes) => {
                    const palletNode = new BABYLON.TransformNode('pallet', sceneRef.current);
                    meshes.forEach(mesh => {
                        mesh.parent = palletNode;
                    });
                    drawBoxes(palletNode, boxType); 
                    resolve(palletNode);
                },
                null,
                (scene, message, exception) => {
                    console.error(message, exception);
                    reject(exception);
                }
            );
        });

        palletMap.set(locationid, pallet); 
    } else if (itmLocationList && itmLocationList.some(item => item.locationId === locationid)) {
        const palletMaterial = pallet.getChildMeshes()[0].material; 
        const isRedPallet = itmLocationList.some(item => item.locationId === locationid);
        palletMaterial.diffuseColor = isRedPallet ? new BABYLON.Color3(1, 0, 0) : new BABYLON.Color3(0.0, 0.0, 0.0);
    }

    return pallet;
};



        const drawAisle = async (aisle) => {
            if (aisle.leftRack) {
                await drawRack(aisle.leftRack, `${aisle.code}L`);
                curZ += bayDepth + aisleSpacing;
            }
            if (aisle.rightRack) {
                await drawRack(aisle.rightRack, `${aisle.code}R`);
                curZ += bayDepth + aisleSpacing;
            }
        };

        const drawRack = async (rack, code) => {
            for (let i = 0; i < 2; i++) {
                for (let j = 0; j < rack.baysCount; j++) {
                    let x = (j - (rack.baysCount / 2)) * (bayWidth + verticalSpacerWidth);
                    if (j % 3 === 0) {
                        const verticalSpacer = BABYLON.MeshBuilder.CreateBox(`verticalSpacer${j}`, { width: verticalSpacerThickness, height: horizontalSpacerSpacing * (rack.shelvesCount + 1), depth: verticalSpacerWidth }, sceneRef.current);
                        verticalSpacer.position.x = x;
                        if (verticalSpacer.position.x < minX) minX = verticalSpacer.position.x;
                        verticalSpacer.position.y = (horizontalSpacerSpacing * (rack.shelvesCount + 1)) / 2;
                        verticalSpacer.position.z = curZ + (i - 0.5) * bayDepth;
                        verticalSpacer.material = new BABYLON.StandardMaterial('verticalSpacerMat', sceneRef.current);
                        verticalSpacer.material.diffuseColor = verticalSpacerColor;
                    }
       
                    if (j === 0) continue;
       
                    for (let k = 0; k < rack.bays[j].shelves.length; k++) {
                        const horizontalSpacer = BABYLON.MeshBuilder.CreateBox(`horizontalSpacer${j}_${k}`, { width: bayWidth + verticalSpacerWidth, height: horizontalSpacerHeight, depth: verticalSpacerWidth }, sceneRef.current);
                        horizontalSpacer.position.x = x - (bayWidth / 2 + horizontalSpacerWidth / 2);
                        horizontalSpacer.position.y = (k + 1) * horizontalSpacerSpacing;
                        horizontalSpacer.position.z = curZ + (i - 0.5) * bayDepth;
                        horizontalSpacer.material = new BABYLON.StandardMaterial('horizontalSpacerMat', sceneRef.current);
                        horizontalSpacer.material.diffuseColor = horizontalSpacerColor;
       
                        if (i === 0) continue;
       
                        if ((j + 2) % 3 === 0) {
                            const horizontalSpacer2 = BABYLON.MeshBuilder.CreateBox(`horizontalSpacer2${j}_${k}`, { width: verticalSpacerThickness, height: horizontalSpacerHeight, depth: bayDepth }, sceneRef.current);
                            horizontalSpacer2.position.x = x - (bayWidth + horizontalSpacerWidth);
                            horizontalSpacer2.position.y = (k + 1) * horizontalSpacerSpacing;
                            horizontalSpacer2.position.z = curZ;
                            horizontalSpacer2.material = new BABYLON.StandardMaterial('horizontalSpacerMat', sceneRef.current);
                            horizontalSpacer2.material.diffuseColor = horizontalSpacerColor;
                        }
       
                        const shouldHaveBox = rack.bays[j].shelves[k].hasBox;
                        const numberofboxes = rack.bays[j].shelves[k].boxType;
                        const locationId = rack.bays[j].shelves[k].locationId;
       
                        if (shouldHaveBox) {
                            const pallet = await drawPallet(numberofboxes, locationId, itmLocationList);
                            pallet.position.x = horizontalSpacer.position.x;
                            pallet.position.y = (k + 1) * horizontalSpacerSpacing + 0.1;
                            pallet.position.z = curZ + 0.1;
                        }

                        // Draw shelf number plane
                        drawShelfNumberPlane(j, k, horizontalSpacer.position);
                    }
                }
            }
        }

        const drawShelfNumberPlane = (bayIndex, shelfIndex, position) => {
            const planeWidth = 0.5;
            const planeHeight = 0.3;

            const plane = BABYLON.MeshBuilder.CreatePlane(`shelfNumber_${bayIndex}_${shelfIndex}`, { width: planeWidth, height: planeHeight }, sceneRef.current);
            plane.position.x = position.x;
            plane.position.y = position.y - 0.025; // Adjust height
            plane.position.z = position.z - 1.4; // Slightly in front of the shelf

            const dynamicTexture = new BABYLON.DynamicTexture(`dynamicTexture_${bayIndex}_${shelfIndex}`, { width: 256, height: 128 }, sceneRef.current);
            const context = dynamicTexture.getContext();

            context.fillStyle = "white";
            context.fillRect(0, 0, 256, 128);
            context.font = "bold 50px Arial";
            context.fillStyle = "black";
            context.fillText(`${bayIndex + 1}-${shelfIndex + 1}`, 10, 70);

            dynamicTexture.update();

            const material = new BABYLON.StandardMaterial(`material_${bayIndex}_${shelfIndex}`, sceneRef.current);
            material.diffuseTexture = dynamicTexture;

            plane.material = material;
            plane.isVisible = false;

            shelfNumberPlanes.push(plane);
        }

        const toggleShelfNumbers = () => {
            shelfNumberPlanes.forEach(plane => {
                plane.isVisible = !plane.isVisible;
            });
        }

        const canvas = canvasRef.current;
        const engine = new BABYLON.Engine(canvas, true);
        engineRef.current = engine;

        const scene = new BABYLON.Scene(engine);
        sceneRef.current = scene;

        drawGround();
        drawWalls();

        const camera = new BABYLON.FreeCamera('camera', new BABYLON.Vector3(0, 30,-40), scene);
        camera.setTarget(BABYLON.Vector3.Zero());
        camera.attachControl(canvas, true);
        camera.ellipsoid = new BABYLON.Vector3(1, 1, 1);
        camera.checkCollisions = true;
        scene.collisionsEnabled = true;
        camera.fov = 0.5;

//         const light = new BABYLON.HemisphericLight('light', new BABYLON.Vector3(0, 1, 0), scene);
        const verticalSpacerColor = new BABYLON.Color3(0.2, 0.2, 0.2);
        const horizontalSpacerColor = new BABYLON.Color3(0.2, 0.2, 0.2);

        let shelfNumberPlanes = [];

        const onKeyDown = (event) => {
        const panSpeed = 0.1;
        switch (event.keyCode) {
            case 37: // Left arrow key
                camera.target.x -= panSpeed;
                break;
            case 38: // Up arrow key
                camera.target.z -= panSpeed;
                break;
            case 39: // Right arrow key
                camera.target.x += panSpeed;
                break;
            case 40: // Down arrow key
                camera.target.z += panSpeed;
                break;
                case 83: // 'S' key to toggle shelf numbers
                    toggleShelfNumbers();
                    break;
                default:
                    break;
            }
        };

        window.addEventListener('keydown', onKeyDown);

        if (aisles.length !== 0) {
            aisles.forEach(async (aisle) => {
                await drawAisle(aisle);
            });
        }

        canvas.addEventListener('wheel', (event) => {
            const delta = event.deltaY;
            const currentPos = camera.position;
            camera.position = new BABYLON.Vector3(currentPos.x, currentPos.y + (delta * 0.005), currentPos.z);
        });

        engine.runRenderLoop(() => {
            scene.render();
        });

        window.addEventListener('resize', () => {
            engine.resize();
        });

        return () => {
            window.removeEventListener('keydown', onKeyDown);
            sceneRef.current.dispose();
            engineRef.current.dispose();
        };
    }, [aisles,itmLocationList]);

    return <>
        <ErrorAlert message={error} setMessage={setError} language={language}/>
        <Navbar className="bg-body-tertiary">
            <Container>
                <MultipleSelectCheckmarks label="Aisles" list={aisleList} onSelectedValuesChanged={(selectedAisles) => {
                    setSelectedAisles(selectedAisles) }
                 
                    } />
                <Form.Check
                    type="checkbox"
                    checked={splitSide}
                    id='splitSide'
                    onChange={e => setSplitSide(!splitSide)}
                    label='Split Sides'
                />
                <AutoComplete
                    as="AutoComplete"
                    placeholder=""
                    serverUrl={serverUrl}
                    props={props}
                    col={column}
                    onChange={e => e ? setItemId(e.option.pkField) : setItemId(null)}
                />
            </Container>
        </Navbar>
        <canvas ref={canvasRef} id="renderCanvas" style={{ width: '100%', height: '100%' }} />;
    </>
};

export default Viewer3D;